<template>
  <div class="login">
    <ui-title :title="t('buttons.login')" :wave="'/authTitleBg.png'" />
    <div class="container">
      <div class="login__wrapper">
        <login-form />
        <img class="login__wave" src="@images/authWave.png" alt="wave">
      </div>
    </div>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import UiTitle from "@/components/ui/ui-title.vue";
import LoginForm from "@/components/forms/login-form.vue";

const {t} = useI18n()
</script>

<style lang="scss" scoped>
.login {
  top: -103px;
  background-color: $white;
  position: relative;

  &__wrapper {
    padding-block: 50px 100px;
  }

  &__wave {
    position: absolute;
    right: 0;
    bottom: 0;
  }
}
</style>